<template>
  <v-stepper v-model="step"
             class="user-create-modal">
    <form @submit.prevent="submit">

      <v-stepper-header>

        <v-stepper-step step="1"
                        editable
                        :complete="step > 1"
                        :edit-icon="$vuetify.icons.complete"></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2"
                        editable
                        :complete="step > 2"></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3"
                        editable
                        :complete="step > 2"></v-stepper-step>

      </v-stepper-header>

      <h1>{{ isEstablishment || isParceiro ? $t('message.admGenerics.message.establishment') : $t('message.admGenerics.message.partner') }}</h1>

      <v-stepper-items>

        <v-stepper-content step="1">

          <app-general-section v-model="form.general"
                               :entity="entity"
                               @advance="step++">

            <app-toggles-section v-model="form.permissions"
                                 :permissions="permissions"></app-toggles-section>
            
          </app-general-section>

        </v-stepper-content>

        <v-stepper-content step="2">

          <app-master-user-section v-model="form.contacts[0]"
                                   @advance="step++"></app-master-user-section>

        </v-stepper-content>

        <v-stepper-content step="3">

          <div class="user-create-modal-contact flex-space-between">

            <div class="flex-col half-width">
              <app-address-section v-model="form.address"></app-address-section>
            </div>

            <div class="flex-col half-width">

              <app-contact-section :label="$t('message.admGenerics.message.secondaryContact')"
                                   v-model="form.contacts[1]"
                                   secondary>
              </app-contact-section>

            </div>
          </div>

          <app-user-modal-footer type="submit">{{$t('message.generics.message.register')}}</app-user-modal-footer>

        </v-stepper-content>

      </v-stepper-items>
    </form>
  </v-stepper>
</template>

<script>
import userModalBody from "./mixins/user-modal-body";

export default {
  components: {},

  mixins: [userModalBody],

  props: {
    permissions: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    isParceiro() {
      return this.$store.state.users.tipo === "PARCEIRO" ? true : false;
    }   
  },
};
</script>

<style lang="scss" scoped>
.user-create-modal {
  h1 {
    text-align: center;
    font-weight: 600;
    margin: 0;
  }

  .user-create-modal-contact {
    gap: 50px;
  }
}
</style>
